/**
 * Created by Viktor on 2016.08.26..
 */
$(function(){
    /*
    $('.creation_contact_open_button').click(function(){
        $('#creation_contact_open').fadeOut(function(){
          $('#creation_contact').show();
        })
    });
    */
    $('.creationContact').submit(function(e){
        e.preventDefault();
        var that = $(this);
        if( $.trim(that.find('input[name=name]').val()) != '' &&
            $.trim(that.find('input[name=email]').val()) != '' &&
            $.trim(that.find('textarea[name=text]').val()) != ''
        ){
            that.find('p').removeClass('error');
            $.ajax({
                url: that.attr('action'),
                method: 'POST',
                dataType: 'json',
                data:{
                    name: that.find('input[name=name]').val(),
                    email: that.find('input[name=email]').val(),
                    text: that.find('textarea[name=text]').val(),
                    tel: that.find('input[name=phone]').val(),
                    cr_id: that.find('button').data('id'),
                    type: that.find('button').data('type'),
                    aszf: that.find('input[name="cb_privacy"]').is(':checked')
                },
                beforeSend: function(){
                    that.find('button.submit').attr('type','button');
                    $('#creation_contact_open').find('.alert').remove();
                },
                success:function(msg){
                    if(msg.result == 'success') {
                        $("#creation_contact").collapse('hide');

                        var div = $('<div>');
                        div.addClass('alert alert-success');
                        //div.css('display','none');
                        div.append('<a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>');
                        div.append('<strong>' + msg.data + '</strong>.');
                        that[0].reset();
                        that.find('button.submit').attr('type', 'submit');
                        $('#creation_contact_open').prepend(div);

                    }
                    else{
                        var div = $('<div>');
                        that.find('button.submit').attr('type', 'submit');
                        div.addClass('alert alert-danger');
                        div.append('<a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>');
                        div.append('<strong>' + msg.data + '</strong>.');
                        $('#creation_contact_open').prepend(div);
                        $('#creation_contact_open').fadeIn();
                    }
                },
                error:function(){

                }
            })
        }else{
            that.find('p').addClass('error');
        }
    });

    /*
    $('.creationContact a#cancel').click(function(){
        $('#creation_contact').fadeOut(function() {
            $('.creationContact')[0].reset();
            $('#creation_contact_open').fadeIn();
        });

    });
     */

    /**
     * tooltipster opciók
     */

    /*
    var options  = {
        contentAsHTML: true,
        interactive: true,
        position: 'top-left',
        functionInit: function(){
            //return $('<a href="'+$(this).data('editlink')+'" target="_blank">Módosítás adminban</a>')
            return $(this).data('text');
        },
        functionBefore : function(origin, continueTooltip) {
            $(this).addClass('tooltip-hovered');
            continueTooltip();
        },
        functionAfter : function(origin) {
            $(this).removeClass('tooltip-hovered');
        }
    };

    $('.tooltipster').tooltipster(options);


    if(typeof editTooltip !== 'undefined') {
        editTooltip.init();
    }

     */
});